import { Discount, DiscountBxgy, DiscountFixedAmount, DiscountPercentage } from '@/models/Discount';
import { formatPrice } from '@/utils/currency';

export interface OrderItemPromotion {
  id: string;
  code: string;
  name: string;
  discounts: Discount[];
}

export interface OrderItem {
  promotions?: OrderItemPromotion[];
}

interface OrderItemPromotionAlertProps {
  item: OrderItem;
}

const OrderItemPromotionAlert = ({ item }: OrderItemPromotionAlertProps) => {
  if ((item?.promotions?.length || 0) !== 1) return;

  const promotion = item?.promotions?.[0];
  if (promotion === undefined) {
    return;
  }

  const discountPercentage = promotion.discounts.find(
    (d): d is DiscountPercentage => d.discountType === 'percentage',
  );
  const discountFixedAmount = promotion.discounts.find(
    (d): d is DiscountFixedAmount => d.discountType === 'fixedAmount',
  );
  const bxgyDiscount = promotion.discounts.find(
    (d): d is DiscountBxgy => d.discountType === 'bxgy',
  );

  let message: string;

  if (discountPercentage) {
    message = `${discountPercentage.percentage}% off`;
  } else if (discountFixedAmount) {
    message = `${formatPrice(discountFixedAmount.amount)} off`;
  } else if (bxgyDiscount) {
    message = `Buy ${bxgyDiscount.buyQuantity} Get ${bxgyDiscount.getQuantity}`;
  } else {
    return;
  }

  return (
    <div
      role="alert"
      className={
        'mt-1 inline-block self-start rounded-md p-2 text-sm' +
        ' bg-green-50 text-green-700 border border-green-100'
      }
    >
      Promotion Applied: <span className="text-nowrap">{message}</span>
    </div>
  );
};

export default OrderItemPromotionAlert;
